module.exports = __webpack_public_path__ + "static/use-case-7-content-2-e0b0790842f411f28cb35e36625a1929.png";